/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import CampaignCannedCollectionModuleRenderer, {
  useShouldShowCampaignCannedCollectionModule,
} from 'bundles/campaigns/module-renderers/CampaignCannedCollectionModuleRenderer';
import type { PromoTemplateCannedCollectionFragment } from 'bundles/front-page/__generated__/contentfulTypes';
import PromoUnitsModuleRenderer from 'bundles/front-page/redesign-modules/promo-units/PromoUnitsModuleRenderer';

type Props = {
  content?: PromoTemplateCannedCollectionFragment;
};

const styles = {
  campaignWrapper: css`
    margin-top: var(--cds-spacing-400);
  `,
  campaignWrapperSticky: css`
    margin-top: 0;
  `,
};

const PromoUnitsDelegator = ({ content }: Props) => {
  const shouldShowCampaignCannedCollectionModule = useShouldShowCampaignCannedCollectionModule();

  if (!shouldShowCampaignCannedCollectionModule) {
    return <PromoUnitsModuleRenderer content={content} />;
  }

  return (
    <div css={content?.stickToPrevious ? styles.campaignWrapperSticky : styles.campaignWrapper}>
      <CampaignCannedCollectionModuleRenderer />
    </div>
  );
};

export default PromoUnitsDelegator;
